import { render, staticRenderFns } from "./SubscriptionOrdersShow.vue?vue&type=template&id=2216d725&scoped=true&lang=pug&"
import script from "./SubscriptionOrdersShow.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOrdersShow.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionOrdersShow.vue?vue&type=style&index=0&id=2216d725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216d725",
  null
  
)

export default component.exports